<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <div class="ListMenu">
        <el-form ref="form" :model="listMenuForm" class="searchForm">
          <el-form-item label="新聞版塊">
            <el-select v-model="block" placeholder="请选择">
              <el-option label="全部" value="0"></el-option>
              <el-option label="vlog" value="2"></el-option>
              <el-option label="小版工" value="3"></el-option>
              <el-option label="新聞" value="4"></el-option>
              <el-option label="社群" value="7"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="發佈時間">
            <el-date-picker
              v-model="listMenuForm.startTime"
              type="date"
              placeholder="選擇時間"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="关键字">
            <el-input
              v-model="listMenuForm.keyword"
              placeholder="請輸入關鍵字"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="MenuBtnWrap">
        <div
          class="btn"
          style="
            background-color: #fff;
            color: #6c3dea;
            border: 1px solid #6c3dea;
          "
          @click="$router.push('/draftNews')"
        >
          草稿箱({{ draftsCount }})
        </div>
        <div class="btn" @click="$router.push('/addNews')">新增新聞</div>
        <div class="btn" @click="search()">查詢</div>
        <div class="btn borderBtn" @click="reset()">重置</div>
      </div>
      <div class="tableWrap">
        <el-table :data="newsList" height="660px" stripe style="width: 100%">
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in newsListTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :show-overflow-tooltip="true"
            :min-width="item.minWidth"
          >
          </el-table-column>
          <el-table-column label="操作" fixed="right" :width="250">
            <template slot-scope="scope">
              <el-button
                class="topBtn"
                v-if="scope.row.roofPlacement == 0"
                @click="toTop(scope.row.id, 1, scope.row.blockStatus)"
                type="text"
                >置頂
              </el-button>
              <el-button
                v-else
                type="text"
                @click="toTop(scope.row.id, 0, scope.row.blockStatus)"
                >取消置頂</el-button
              >
              <el-button
                :disabled="scope.row.status === '已隐藏'"
                @click="
                  editNews(scope.row.id, scope.row.type, scope.row.status)
                "
                type="text"
                >修改</el-button
              >
              <el-dropdown style="margin-left: 5px; cursor: pointer">
                <span style="color: #6c3dea">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <el-button @click="viewComments(scope.row.id)" type="text"
                      >查看評論</el-button
                    >
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button @click="delNews(scope.row.id)" type="text"
                      >刪除</el-button
                    ></el-dropdown-item
                  >
                  <el-dropdown-item>
                    <el-button
                      @click="getHide(scope.row.id, scope.row.status)"
                      type="text"
                      >{{
                        scope.row.status != "已隐藏" ? "隐藏" : "已隐藏"
                      }}</el-button
                    >
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          @size-change="handleSizeChange"
          :page-sizes="[20, 30]"
          :page-size="currentPageSize"
          :pager-count="5"
          layout="sizes,prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      navBlock: "新聞",
      navtitle: "新聞列表",
      listMenuForm: {
        startTime: "",
        endTime: "",
        keyword: "",
      },
      newsList: [],
      block: "0",
      newsListTable: [
        {
          prop: "id",
          label: "ID",
          width: "180",
        },
        {
          prop: "title",
          label: "新聞名稱",
          width: "",
          minWidth: "200",
        },
        {
          prop: "block",
          label: "新聞版塊",
          width: "120",
        },
        {
          prop: "publishDate",
          label: "發佈時間",
          width: "200",
        },
        {
          prop: "status",
          label: "發佈狀態",
          width: "120",
        },
        {
          prop: "commentNum",
          label: "評論",
          width: "80",
        },
        {
          prop: "likeNum",
          label: "讚數",
          width: "80",
        },
        {
          prop: "pageView",
          label: "瀏覽數",
          width: "80",
        },
        {
          prop: "vip",
          label: "權限",
          width: "100",
        },
      ],
      total: 50,
      currentPageSize: 20,
      currentPage: 1,
      dialogVisible: false,
      draftsCount: 0,
    };
  },
  activated() {
    let _this = this;
    _this.initList();
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    initList() {
      let _this = this;
      let param = {
        type: _this.block === "" ? 0 : Number(_this.block),
        page: _this.currentPage,
        size: _this.currentPageSize,
        title: _this.listMenuForm.keyword ? _this.listMenuForm.keyword : null,
        drafts: 1,
        startTime:
          _this.listMenuForm.startTime === "" ||
          _this.listMenuForm.startTime === null
            ? null
            : _this.$formatDate(_this.listMenuForm.startTime),
        endTime:
          _this.listMenuForm.startTime === "" ||
          _this.listMenuForm.startTime === null
            ? null
            : _this.$formatDate(_this.listMenuForm.startTime).substring(0, 10) +
              " 23:59:59",
      };
      _this
        .$post(
          "/request/article/getArticleList",
          param,
          _this.$GLOBAL.jsonConfig
        )
        .then((res) => {
          if (res.code === "00000") {
            _this.newsList = res.data.list.forEach((v) => {
              //新聞版塊分類
              switch (v.type) {
                case 0:
                  v.block = "全部";
                  v.vip = "非會員";
                  break;
                case 2:
                  v.block = "vlog";
                  v.vip = "會員";
                  v.blockStatus = 2;
                  break;
                case 3:
                  v.block = "小版工";
                  v.vip = "會員";
                  v.blockStatus = 3;
                  break;
                case 4:
                  v.block = "新聞";
                  v.vip = "非會員";
                  v.blockStatus = 4;
                  break;
                case 7:
                  v.block = "社群";
                  (v.vip = "非會員"), (v.blockStatus = 7);
                  break;
              }
              if (v.status === 1) {
                v.status = "已發佈";
              } else if (v.status === 2) {
                v.status = "待發佈";
              } else if (v.status === 3) {
                v.status = "已隐藏";
              }
            });
            _this.newsList = res.data.list;
            _this.total = res.data.allRow;
            _this.draftsCount = res.data.draftsCount;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.initList();
    },
    handleSizeChange(val) {
      let _this = this;
      _this.currentPageSize = val;
      _this.initList();
    },
    // 重置
    reset() {
      let _this = this;
      _this.block = "";

      _this.listMenuForm = {
        startTime: "",
        endTime: "",
      };
      _this.currentPage = 1;
      _this.initList();
    },
    // 搜索新聞
    search() {
      let _this = this;
      if (
        _this.block === "" &&
        (_this.listMenuForm.startTime === "" ||
          _this.listMenuForm.startTime === null)
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("請輸入至少一個搜索條件", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      _this.currentPage = 1;
      _this.initList();
    },
    // 刪除新聞
    delNews(id) {
      let _this = this;
      this.$confirm("是否刪除該新聞?", "提示信息", {
        confirmButtonText: "確認",
        cancelButtonText: "取消",
        center: true,
        closeOnClickModal: false,
      }).then(() => {
        // 确认删除的回调
        _this
          .$get(`/request/article/deleteNews/${id}`, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              if (_this.newsList.length == 1 && _this.currentPage > 1) {
                _this.currentPage--;
              }
              _this.$propMessage("刪除成功", "success", function () {
                _this.dialogVisible = false;
                _this.block = "";
                _this.initList();
              });
            } else {
              _this.$propMessage(res.message, "error", function () {
                _this.dialogVisible = false;
              });
            }
          });
      });
    },
    //隐藏
    getHide(id, status) {
      let param = { id: id, hide: status == "已隐藏" ? 0 : 1 };
      let _this = this;
      _this
        .$post(`/request/article/hide`, param, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          _this.dialogVisible = true;
          if (res.code === "00000") {
            if (status == "已隐藏") {
              _this.$propMessage("取消隐藏成功", "success", function () {
                _this.dialogVisible = false;
                _this.initList();
              });
            } else {
              _this.$propMessage("隐藏成功", "success", function () {
                _this.dialogVisible = false;
                _this.initList();
              });
            }
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    // 修改新闻
    editNews(id, type, status) {
      this.$get(`/request/article/getArticleDetail/${id}`).then((res) => {
        if (res.code === "00000") {
          this.$router.push(
            `/editNews?id=${id}&type=${type}&status=${
              status === "已發佈" ? 1 : status === "已隐藏" ? 3 : 0
            }&push=${res.data.push == 1 ? true : false}&pageType=edit`
          );
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },
    //查看评论
    viewComments(id) {
      this.$router.push(`/viewComment?id=${id}&fromPage=news`);
    },
    // 新聞置頂
    toTop(id, flag, type) {
      let _this = this;
      let text = "";
      if (type == "3") {
        text = "小版工";
      } else if (type == "4") {
        text = "新聞";
      } else if (type == "4") {
        text = "社群";
      }
      let param = {
        articleType: Number(type),
        articleId: id,
        top: Number(flag),
      };

      _this
        .$put(`/request/article/articleTop`, param, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          _this.dialogVisible = true;
          if (res.code === "00000") {
            if (flag == 0) {
              _this.$propMessage(
                `${text}新聞取消置頂成功，請稍候`,
                "success",
                function () {
                  _this.dialogVisible = false;
                  _this.initList();
                }
              );
            } else {
              _this.$propMessage(
                `${text}新聞置頂成功，請稍候`,
                "success",
                function () {
                  _this.dialogVisible = false;

                  _this.initList();
                }
              );
            }
          } else if (res.code === "80001") {
            this.$confirm(
              `${text}同時只支持一篇新聞置頂，請取消置頂後再設置?`,
              "提示信息",
              {
                confirmButtonText: "確認",
                cancelButtonText: "取消",
                center: true,
                closeOnClickModal: false,
              }
            ).then(() => {});
          } else {
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
            });
          }
        });
    },
  },
  components: {
    NavBar,
    DiaMess,
  },
};
</script>
<style lang="less" scoped>
.content {
  .paddingContent {
    .ListMenu {
      .MenuBtnWrap {
        display: flex;
        justify-content: flex-end;

        .btn:last-child {
          margin-left: 0.2rem;
        }
      }
    }

    .tableWrap {
      width: 100%;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }
    }
  }

  .topBtn {
    width: 50px;
  }
}

@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;

    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;
    }

    .MenuBtnWrap {
      flex: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/news/newsList.vue